type Props = {
  src: string;
  alt: string;
  href: string;
};

export function ButtonSocial(props: Props) {
  const { src, alt, href } = props;

  return (
    <a
      className='inline-flex size-10 items-center justify-center rounded-lg bg-gray-100 p-2'
      href={href}
      rel='nofollow noreferrer'
      target='_blank'
    >
      <div className='relative flex size-6 flex-col items-start justify-start'>
        <img alt={alt} className='size-6' src={src} />
      </div>
    </a>
  );
}
